export const maskPhoneNumber = (phoneNumber: string | undefined) => {
  if (!phoneNumber) {
    return '';
  }

  phoneNumber = unmaskPhoneNumber(phoneNumber);
  if (phoneNumber.length > 6) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
  } else if (phoneNumber.length > 3) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}`;
  } else {
    return phoneNumber;
  }
};

export const unmaskPhoneNumber = (phoneNumber: string | undefined) => {
  return `${phoneNumber?.replace(/\D/g, '')}`;
};
